import { render, staticRenderFns } from "./robot3.vue?vue&type=template&id=d9931e2a&scoped=true&"
import script from "./robot3.vue?vue&type=script&lang=js&"
export * from "./robot3.vue?vue&type=script&lang=js&"
import style0 from "./robot3.vue?vue&type=style&index=0&id=d9931e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9931e2a",
  null
  
)

export default component.exports